import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/ClassicElegance.css';

const ClassicElegance = ({ isPreview = true }) => {
  const { coupleNames } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse couple names
  const formatCoupleNames = (names) => {
    if (!names) return 'Bride & Groom';
    return names
      .split('-')
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' & ');
  };

  const invitationData = {
    coupleNames: formatCoupleNames(coupleNames),
    groomName: coupleNames?.split('-')[0]?.charAt(0).toUpperCase() + coupleNames?.split('-')[0]?.slice(1).toLowerCase() || 'John',
    brideName: coupleNames?.split('-')[1]?.charAt(0).toUpperCase() + coupleNames?.split('-')[1]?.slice(1).toLowerCase() || 'Jane',
    weddingDate: 'March 15, 2026',
    weddingDay: 'Sunday',
    ceremonyTime: '3:00 PM',
    churchName: 'San Agustin Church',
    churchAddress: 'Intramuros, Manila',
    receptionVenue: 'Manila Hotel Grand Ballroom',
    receptionAddress: 'One Rizal Park, Manila',
    message: 'Together with their families, request the honor of your presence at the celebration of their marriage.',
    dressCode: 'Formal Attire',
    colors: 'Ivory & Gold'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="classic-elegance">
      {/* Decorative Elements */}
      <div className="decorative-elements">
        <div className="corner-ornament top-left"></div>
        <div className="corner-ornament top-right"></div>
        <div className="corner-ornament bottom-left"></div>
        <div className="corner-ornament bottom-right"></div>
      </div>

      {/* Main Content */}
      <div className={`classic-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="classic-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="classic-section home-section">
            <div className="classic-frame">
              <div className="frame-border">
                <div className="ornamental-line top"></div>
                
                <div className="home-content">
                  <p className="invitation-prefix">Together with their families</p>
                  
                  <div className="couple-names">
                    <span className="name groom">{invitationData.groomName}</span>
                    <span className="ampersand">&</span>
                    <span className="name bride">{invitationData.brideName}</span>
                  </div>

                  <div className="elegant-divider">
                    <span className="divider-ornament">❧</span>
                  </div>

                  <p className="invitation-text">{invitationData.message}</p>

                  <div className="wedding-date-display">
                    <div className="date-wrapper">
                      <span className="day-name">{invitationData.weddingDay}</span>
                      <div className="date-main">
                        <span className="month">March</span>
                        <span className="day-number">15</span>
                        <span className="year">2026</span>
                      </div>
                      <span className="time">{invitationData.ceremonyTime}</span>
                    </div>
                  </div>

                  <button 
                    className="view-details-btn"
                    onClick={() => setActiveSection('details')}
                  >
                    View Details
                  </button>
                </div>

                <div className="ornamental-line bottom"></div>
              </div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="classic-section details-section">
            <h2 className="section-title">
              <span className="title-ornament">❧</span>
              Wedding Details
              <span className="title-ornament">❧</span>
            </h2>

            <div className="details-grid">
              <div className="detail-card">
                <div className="detail-icon">⛪</div>
                <h3>Ceremony</h3>
                <p className="venue-name">{invitationData.churchName}</p>
                <p className="venue-address">{invitationData.churchAddress}</p>
                <p className="venue-time">{invitationData.ceremonyTime}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🥂</div>
                <h3>Reception</h3>
                <p className="venue-name">{invitationData.receptionVenue}</p>
                <p className="venue-address">{invitationData.receptionAddress}</p>
                <p className="venue-time">Immediately following the ceremony</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">👔</div>
                <h3>Dress Code</h3>
                <p className="dress-info">{invitationData.dressCode}</p>
                <p className="color-info">Colors: {invitationData.colors}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">💝</div>
                <h3>Gift Registry</h3>
                <p className="gift-message">Your presence is the greatest gift.</p>
                <p className="gift-note">However, if you wish to bless us, monetary gifts are appreciated.</p>
              </div>
            </div>

            <div className="countdown-section">
              <h3>Counting Down to Our Forever</h3>
              <div className="countdown-display">
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Minutes</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Seconds</span>
                </div>
              </div>
            </div>

            <button 
              className="rsvp-cta-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              RSVP Now
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="classic-section rsvp-section">
            <h2 className="section-title">
              <span className="title-ornament">❧</span>
              RSVP
              <span className="title-ornament">❧</span>
            </h2>

            <form className="classic-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">We would be honored to have you celebrate with us!</p>
              <p className="rsvp-deadline">Kindly respond by February 15, 2026</p>

              <div className="form-group">
                <label>Your Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you be attending?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✓</span>
                    <span className="option-text">Joyfully Accepts</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✗</span>
                    <span className="option-text">Regretfully Declines</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message for the Couple (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Share your wishes..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="submit-rsvp-btn" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="classic-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Created with ♥ by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default ClassicElegance;
